import { useTheme } from '@shopify/polaris-viz-core';
import styles from './ComparisonMetric.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { DownChevron } from './components/DownChevron/DownChevron.js';
import { UpChevron } from './components/UpChevron/UpChevron.js';

function ComparisonMetric({
  metric,
  trend,
  accessibilityLabel
}) {
  const selectedTheme = useTheme();

  switch (trend) {
    case 'neutral':
      return /*#__PURE__*/jsxs("span", {
        className: styles.NeutralIcon,
        children: [/*#__PURE__*/jsx("span", {
          className: styles.VisuallyHidden,
          children: accessibilityLabel
        }), /*#__PURE__*/jsx("span", {
          style: {
            color: selectedTheme.legend.trendIndicator.neutral
          },
          children: "-"
        })]
      });

    case 'positive':
      return /*#__PURE__*/jsxs("span", {
        className: styles.PositiveIcon,
        children: [/*#__PURE__*/jsx(UpChevron, {
          accessibilityLabel: accessibilityLabel,
          fill: selectedTheme.legend.trendIndicator.positive
        }), /*#__PURE__*/jsx("span", {
          style: {
            color: selectedTheme.legend.trendIndicator.positive
          },
          children: metric
        })]
      });

    case 'negative':
      return /*#__PURE__*/jsxs("span", {
        className: styles.NegativeIcon,
        children: [/*#__PURE__*/jsx(DownChevron, {
          accessibilityLabel: accessibilityLabel,
          fill: selectedTheme.legend.trendIndicator.negative
        }), /*#__PURE__*/jsx("span", {
          style: {
            color: selectedTheme.legend.trendIndicator.negative
          },
          children: metric
        })]
      });
  }
}

export { ComparisonMetric };
